import { ChangeEvent } from 'react';
import { Card, CardContent, CardHeader, Typography, FormGroup } from '@mui/material';
import { Columns } from '@assets/svgs';
import { Checkbox, FormControlLabel } from '@components/index';
import * as styles from '@components/card/dataGrid/styles';

export type ColumnVisibility = Record<string, boolean>;
export interface CardColumnSelectorProps {
  columnSelector: { [key: string]: Record<string, string> };
  defaultDisabledKey: string;
  columnVisibility: Record<string, ColumnVisibility>;
  selectableColumns: string[];
  updateColumnVisibility: (k: string, v: boolean) => void;
  visibleColumnCount: number;
  type: string;
  updateLastColumnsChecked: (type: any, columnKey: string, checked: boolean) => void;
}
export const CardColumnSelector = ({
  columnVisibility,
  columnSelector,
  defaultDisabledKey,
  selectableColumns,
  type,
  updateColumnVisibility,
  updateLastColumnsChecked,
  visibleColumnCount,
}: CardColumnSelectorProps) => {
  const checkedColumnsCount = selectableColumns.filter((c) => columnVisibility[type][c])?.length;
  const isVisibleColumnLimit: boolean = checkedColumnsCount === visibleColumnCount;
  const handleOnChange = (columnKey: string, event: ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    updateColumnVisibility(columnKey, checked);
    updateLastColumnsChecked(type, columnKey, checked);
  };
  const columnDisabled = (columnKey: string) => {
    if (columnKey === defaultDisabledKey) return true;
    if (columnVisibility[type][columnKey]) return false;
    return isVisibleColumnLimit;
  };

  return (
    <Card elevation={0} sx={styles.cardContainer}>
      <CardHeader
        disableTypography
        title={
          <>
            <Typography variant='h5'>Display Columns</Typography>
            <Columns />
          </>
        }
      />
      <CardContent>
        <FormGroup>
          {selectableColumns.map((columnKey) => (
            <FormControlLabel
              key={columnKey}
              value={columnKey}
              label={columnSelector[type][columnKey] ?? columnKey}
              checked={columnVisibility[type][columnKey]}
              disabled={columnDisabled(columnKey)}
              control={<Checkbox value={columnKey} onChange={(event) => handleOnChange(columnKey, event)} />}
            />
          ))}
        </FormGroup>
      </CardContent>
    </Card>
  );
};
